module.exports = __webpack_public_path__ + "img/Token_p6.8a06ffbd.png";